<template>
<div>
  <sub-slider :slider-items="sliderItems"/>
  <mainGlassProducts/>
  <mainGlassProjects/>
  <mainGlassProductionLines/>
  <mainGlassDownloads/>
  <main-glass-hint/>

</div>
</template>

<script>
import mainGlassProducts from "./components/mainGlassProducts";
import mainGlassProjects from "./components/mainGlassProjects";
import mainGlassProductionLines from "./components/mainGlassProductionLines";
import mainGlassDownloads from "./components/mainGlassDownloads";
import mainGlassHint from "./components/mainGlassHint";
import {mapState} from "vuex";

export default {
  name: "mainGlass",
  components: {mainGlassProducts, mainGlassProjects, mainGlassProductionLines, mainGlassDownloads,mainGlassHint},
  data(){
    return{
      headerItems:[
        {
          name:'صفحه اصلی',
          type:'single',
          route:'/',
          subDomain:[]
        },
        {
          name:'درباره ما',
          type:'sublayer',
          route:'',
          expanded: false,
          subDomain:[
            {
              name:'معرفی مجموعه',
              route:'/about-ardakan'
            },
            {
              name:'مدیریت',
              route:'/management'
            },
            {
              name:'صادرات',
              route:'/export'
            },
          ]
        },
        {
          name:'اخبار',
          type:'sublayer',
          route:'',
          expanded: false,
          subDomain:[
            {
              name:'رویداد‌ها و نمایشگاه ها',
              route:'/show-place'
            },
            {
              name:'پروژه ها',
              route:'/projects'
            },
            {
              name: 'گالری',
              route: '/gallery'
            },
            {
              name:'سایر اخبار',
              route:'/all-news'
            },
          ]
        },
        {
          name:'محصولات',
          type:'sublayer',
          route:'',
          expanded: false,
          subDomain: [
            {
              name:'شیشه فلوت',
              route:''
            },
            {
              name:'صنایع جانبی',
              route:''
            },
            {
              name:'شیشه های صنعتی',
              route:''
            },
            {
              name:'شیشه های High Performance',
              route:'/sub/cement-block'
            },
          ]
        },


        {
          name: 'اطلاعات فنی',
          type: 'sublayer',
          expanded: false,
          route: '',
          subDomain: [
            {
              name: 'گواهینامه‌ها و افتخارات',
              route: '/certificates'
            },
            {
              name: 'مقالات',
              route: '/news'
            },
            {
              name: 'گالری',
              route: '/gallery'
            },
            {
              name: 'سوالات متداول',
              route: '/faq'
            },
          ]
        },
        {
          name:'عاملیت شبکه',
          type:'sublayer',
          route:'',
          expanded: false,
          subDomain:[
            {
              name:'درخواست همکاری',
              route:''
            },
            {
              name:'شرایط نمایندگی',
              route:''
            },
            {
              name:"درخواست همکاری",
              route:''
            }
          ]
        },
        {
          name:'پنل کاربری',
          type:'single',
          route:'/',
          subDomain:[]
        },
        {
          name:'تماس با ما',
          type:'single',
          route:'/',
          subDomain:[]
        },
        //   {
        //   name:'تماس با ما',
        //   type:'single',
        //   route:'contact-us',
        //   subDomain:[]
        // },

      ],
    }
  },
  computed:{
    ...mapState({
      sliderItems:state => state.glassManagement.glassHomeBanner,
      video:state => state.glassManagement.glassVideo,
    })
  },
  created() {
    this.$store.dispatch('glassManagement/getGlassHomeBanner');
    this.$store.dispatch('glassManagement/getGlassHomeCatalogue');
    this.$store.dispatch('glassManagement/getGlassHomeFeatures');
    this.$store.dispatch('glassManagement/getGlassNews');
    this.$store.dispatch('glassManagement/getGlassProjects');
    this.$store.dispatch('glassManagement/getGlassProducts');
    this.$store.dispatch('glassManagement/getGlassVideo').then(res=>{
      setTimeout(()=>{
        document.querySelector("#glassVideo").load()
      },500)
    });
    
  }
}
</script>

